// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --ruffle-blue: #37528c;
    --ruffle-orange: #ffad33;
    --splash-screen-background: #31497d;
}

body {
    position: absolute;
    inset: 0;
    padding: 0;
    margin: 0;
    font-family: Lato, sans-serif;
    display: flex;
    flex-flow: column;
    background: black;
}

#main {
    position: relative;
    flex: 1;
}

#overlay {
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
    border: 8px dashed var(--ruffle-orange);
    border-radius: 30px;
    opacity: 0;
    transition: opacity 0.3s ease-in;
    margin: 10px 5px;
}

#overlay.drag {
    opacity: 1;
    transition-timing-function: ease-out;
}

#player {
    position: absolute;
    inset: 0;
    width: auto;
    height: auto;
    margin: 10px 0;
}

#nav {
    width: 100%;
    background: var(--ruffle-blue);
    box-shadow: 0 3px 6px 5px var(--ruffle-blue);
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: white;
    padding: 10px 0 5px;
    margin-bottom: 5px;
}

#title {
    transition: opacity 0.5s;
}

#title:hover {
    opacity: 0.5;
}

#title img {
    height: 32px;
}

#file-picker select,
#file-picker input,
#author {
    margin-left: 5px;
}

#local-file-container,
#sample-swfs-container {
    display: inline-block;
    vertical-align: middle;
}

#local-file {
    width: 0;
    opacity: 0;
    position: absolute;
}

#local-file-label {
    color: var(--ruffle-blue);
    padding: 3px 10px;
    margin: 5px 2px;
    cursor: pointer;
    border-radius: 50px;
    background-color: white;
}

#local-file-name {
    min-width: 150px;
    display: inline-block;
    font-size: smaller;
}

#sample-swfs {
    background-color: white;
    color: var(--ruffle-blue);
    border: 1px solid white;
    border-radius: 5px;
}

#author-container {
    font-size: small;
}

#author {
    color: var(--ruffle-orange);
}

.hidden {
    display: none !important;
}

.modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}

.modal-content {
    background-color: var(--ruffle-blue);
    margin: 15vh auto;
    padding: 20px;
    border: 2px solid white;
    width: 300px;
    height: 270px;
    overflow: auto;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
}

#open-modal,
#reload-swf {
    vertical-align: middle;
    cursor: pointer;
}

#metadata {
    margin: 0 auto;
}

#metadata td {
    padding: 2px 1px;
    border: 1px solid #ddd;
    color: var(--ruffle-orange);
}

#metadata tr td:nth-child(1) {
    font-weight: bold;
    padding: 0 10px;
}

@media only screen and (width <= 800px) {
    #local-file-container,
    #sample-swfs-container {
        display: block;
    }

    #local-file-container {
        margin-bottom: 10px;
    }
}

@media only screen and (width <= 600px) {
    #local-file-static-label,
    #sample-swfs-label {
        display: block;
        margin-bottom: 5px;
    }

    #author-container {
        font-size: 12px;
        text-align: center;
    }

    #nav {
        flex-flow: column;
    }
}
`, "",{"version":3,"sources":["webpack://./www/index.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,SAAS;IACT,6BAA6B;IAC7B,aAAa;IACb,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,oBAAoB;IACpB,uCAAuC;IACvC,mBAAmB;IACnB,UAAU;IACV,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI;;QAEI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;;QAEI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[":root {\n    --ruffle-blue: #37528c;\n    --ruffle-orange: #ffad33;\n    --splash-screen-background: #31497d;\n}\n\nbody {\n    position: absolute;\n    inset: 0;\n    padding: 0;\n    margin: 0;\n    font-family: Lato, sans-serif;\n    display: flex;\n    flex-flow: column;\n    background: black;\n}\n\n#main {\n    position: relative;\n    flex: 1;\n}\n\n#overlay {\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    pointer-events: none;\n    border: 8px dashed var(--ruffle-orange);\n    border-radius: 30px;\n    opacity: 0;\n    transition: opacity 0.3s ease-in;\n    margin: 10px 5px;\n}\n\n#overlay.drag {\n    opacity: 1;\n    transition-timing-function: ease-out;\n}\n\n#player {\n    position: absolute;\n    inset: 0;\n    width: auto;\n    height: auto;\n    margin: 10px 0;\n}\n\n#nav {\n    width: 100%;\n    background: var(--ruffle-blue);\n    box-shadow: 0 3px 6px 5px var(--ruffle-blue);\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    color: white;\n    padding: 10px 0 5px;\n    margin-bottom: 5px;\n}\n\n#title {\n    transition: opacity 0.5s;\n}\n\n#title:hover {\n    opacity: 0.5;\n}\n\n#title img {\n    height: 32px;\n}\n\n#file-picker select,\n#file-picker input,\n#author {\n    margin-left: 5px;\n}\n\n#local-file-container,\n#sample-swfs-container {\n    display: inline-block;\n    vertical-align: middle;\n}\n\n#local-file {\n    width: 0;\n    opacity: 0;\n    position: absolute;\n}\n\n#local-file-label {\n    color: var(--ruffle-blue);\n    padding: 3px 10px;\n    margin: 5px 2px;\n    cursor: pointer;\n    border-radius: 50px;\n    background-color: white;\n}\n\n#local-file-name {\n    min-width: 150px;\n    display: inline-block;\n    font-size: smaller;\n}\n\n#sample-swfs {\n    background-color: white;\n    color: var(--ruffle-blue);\n    border: 1px solid white;\n    border-radius: 5px;\n}\n\n#author-container {\n    font-size: small;\n}\n\n#author {\n    color: var(--ruffle-orange);\n}\n\n.hidden {\n    display: none !important;\n}\n\n.modal {\n    display: none;\n    position: fixed;\n    z-index: 1;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.modal-content {\n    background-color: var(--ruffle-blue);\n    margin: 15vh auto;\n    padding: 20px;\n    border: 2px solid white;\n    width: 300px;\n    height: 270px;\n    overflow: auto;\n}\n\n.close {\n    color: #aaa;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n#open-modal,\n#reload-swf {\n    vertical-align: middle;\n    cursor: pointer;\n}\n\n#metadata {\n    margin: 0 auto;\n}\n\n#metadata td {\n    padding: 2px 1px;\n    border: 1px solid #ddd;\n    color: var(--ruffle-orange);\n}\n\n#metadata tr td:nth-child(1) {\n    font-weight: bold;\n    padding: 0 10px;\n}\n\n@media only screen and (width <= 800px) {\n    #local-file-container,\n    #sample-swfs-container {\n        display: block;\n    }\n\n    #local-file-container {\n        margin-bottom: 10px;\n    }\n}\n\n@media only screen and (width <= 600px) {\n    #local-file-static-label,\n    #sample-swfs-label {\n        display: block;\n        margin-bottom: 5px;\n    }\n\n    #author-container {\n        font-size: 12px;\n        text-align: center;\n    }\n\n    #nav {\n        flex-flow: column;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
